import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "34",
  height: "31",
  viewBox: "0 0 34 31",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      id: "vector",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.6801 2.76287C14.6095 -0.544651 19.3885 -0.544659 21.3179 2.76287L33.0144 22.8141C34.9589 26.1474 32.5545 30.3334 28.6955 30.3334H5.30245C1.4435 30.3334 -0.960859 26.1474 0.983558 22.8141L12.6801 2.76287ZM17.0007 10.3335C17.9211 10.3335 18.6673 11.0797 18.6673 12.0002V17.0002C18.6673 17.9206 17.9211 18.6668 17.0007 18.6668C16.0802 18.6668 15.334 17.9206 15.334 17.0002V12.0002C15.334 11.0797 16.0802 10.3335 17.0007 10.3335ZM14.9173 22.0002C14.9173 20.8496 15.8501 19.9168 17.0007 19.9168C18.1512 19.9168 19.084 20.8496 19.084 22.0002C19.084 23.1508 18.1512 24.0835 17.0007 24.0835C15.8501 24.0835 14.9173 23.1508 14.9173 22.0002Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }